<template>

    <div>

        <b-card>

            <b-row>

                <b-col>

                    <b-alert variant="info" show><h3 class="d-inline-block mb-0">Note:</h3> All idle records are picked up every hour for processing</b-alert>
                </b-col>
            </b-row>

            <b-row class="mb-2">

                <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">

                    <date-picker
                        v-model="start_date"
                        placeholder="Start Date"
                        class="f-1">
                    </date-picker> &nbsp;to&nbsp;
                    <date-picker
                        v-model="end_date"
                        placeholder="End Date"
                        class="f-1">
                    </date-picker>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <b-form-select v-model=" status ">

                        <option value="">-- Show All --</option>
                        <option value="idle">Idle</option>
                        <option value="pending">Pending</option>
                        <option value="rejected">Rejected</option>
                        <option value="successful">Successful</option>
                        <option value="needs_review">Needs Review</option>
                    </b-form-select>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <b-form-select v-model=" error ">

                        <option value="">-- No Errors Specified --</option>
                        <option value="errors_present">Errors present</option>
                        <option value="unknown_carrier">Unknown carrier</option>
                        <option value="unknown_action">Unknown action</option>
                        <option value="failed_validation">Failed validation</option>
                        <option value="matched_multiple_inactive_claimants">Matched multiple inactive claimants</option>
                        <option value="matched_multiple_claimants">Matched multiple claimants</option>
                        <option value="matched_multiple_providers">Matched multiple providers</option>
                        <option value="matched_no_claimants">Matched no claimants</option>
                        <option value="matched_no_providers">Matched no providers</option>
                        <option value="cannot_build_claimant">Cannot build claimant</option>
                        <option value="cannot_build_provider">Cannot build provider</option>
                        <option value="fuzzy_match_problems">Fuzzy match problems</option>
                        <option value="fuzzy_match_found_multiple">Fuzzy match found multiple</option>
                        <option value="pair_not_already_matched">Pair not already matched</option>
                        <option value="pair_updated_but_not_already_matched">Pair updated but not already matched</option>
                        <option value="pair_already_matched">Pair already matched</option>
                        <option value="claimant_has_active_shifts">Claimant has active shifts</option>
                        <option value="multiple_active_providers_found_in_care_exchange">Multiple active providers found in care exchange</option>
                        <option value="no_active_providers_found_in_care_exchange">No active providers found in care exchange</option>
                        <option value="provider_upd_doesnt_match_import_upd">Provider upd doesnt match import upd</option>
                        <option value="fuzzy_match_upd_not_equal_to_careexchange">Fuzzy match upd not equal to careexchange</option>
                        <option value="created_new_provider_in_upd_even_though_careexchange_had_upd">Created new provider in upd even though careexchange had upd</option>
                        <option value="import_identifier_failed_to_match_provider_in_care_exchange_contact_support_to_resolve">Import identifier failed to match provider in care exchange contact support to resolve</option>
                        <option value="two_separate_providers_were_matched_based_on_internal_id_and_upd_id_please_manually_correct_by_transferring_both_upd_and_internal_id_to_one_provider">Two separate providers were matched based on internal id and upd id please manually correct by transferring both upd and internal id to one provider</option>
                        <option value="user_with_provider_email_already_exists_in_care_exchange">User with provider email already exists in care exchange</option>
                        <option value="user_with_claimant_email_already_exists_in_care_exchange">User with claimant email already exists in care exchange</option>
                    </b-form-select>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <carrier-dropdown v-model=" ltc_carrier_id "></carrier-dropdown>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <b-form-select v-model=" action ">

                        <option value="">-- No Action Specified --</option>
                        <option value="add">Add</option>
                        <option value="update">Update</option>
                        <option value="delete">Delete</option>
                        <option value="delete-claim">Delete Claimant</option>
                        <option value="delete-provider">Delete Provider</option>
                    </b-form-select>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <b-form-input type="number" v-model=" ip_sync_file_id " placeholder="Lookup Specific Ip Sync File By ID"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mb-3">

                <b-col sm="12" class="d-flex align-items-center justify-content-between">

                    <p class="m-0 mt-1">Total: {{ totalRows }}</p>
                    <div class="d-flex align-items-center">

                        <b-button variant="success" @click=" queueAll() " class="mr-2 d-flex align-items-center" v-b-tooltip.hover title="Queue all 'needs review' records"><i class="fa fa-recycle mr-1"></i>Queue All</b-button>
                        <b-button variant="info" @click=" loadTable() ">Generate</b-button>
                    </div>
                </b-col>
            </b-row>

            <div class="table-responsive">

                <b-table bordered striped hover show-empty
                    :items=" items "
                    :fields=" fields "
                    :current-page=" currentPage "
                    :per-page=" 0 "
                    :sort-by.sync=" sortBy "
                    :sort-desc.sync=" sortDesc "
                    :busy=" loading "
                >

                    <template v-slot:cell(actions)="row">

                        <div class="d-flex align-items-center">

                            <b-btn v-b-tooltip.hover title="Inspect Record Details" class="f-1 mr-1" size="sm" variant="info" :href=" `/business/parking_lots/${row.item.id}` " target="_blank"><i class="fa fa-edit"></i></b-btn>
                            <b-btn v-b-tooltip.hover title="Reject Record" class="f-1 mr-1" size="sm" variant="danger" @click=" rejectRecord( row.item ) " :disabled=" row.item.status == 'pejected' "><i class="fa fa-ban"></i></b-btn>
                            <b-btn v-b-tooltip.hover title="Re-Queue Record" class="f-1" size="sm" variant="success" @click=" queueRecord( row.item ) " :disabled=" row.item.status == 'pending' "><i class="fa fa-recycle"></i></b-btn>
                        </div>
                    </template>
                    <template v-slot:cell(errors)="row">

                        <span v-b-tooltip.hover :title=" formatErrors( row.item.errors ) ">{{ row.item.errors.length > 0 ? 'Yes' : 'No' }}</span>
                    </template>
                </b-table>
            </div>

            <b-row>

                <b-col lg="6" >

                    <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                </b-col>
                <b-col lg="6" class="text-right">

                    {{ paginationText }}
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>

    import PaginatedTable from "../../mixins/PaginatedTable";
    import FormatsDates from "../../mixins/FormatsDates";

    export default {

        mixins: [ PaginatedTable, FormatsDates ],
        data() {

            return {

                baseUrl         : '/business/parking_lots',

                start_date      : '',
                end_date        : '',
                ip_sync_file_id : '',
                status          : 'needs_review',
                ltc_carrier_id  : '',
                error           : '',
                action          : '',

                fields : [
                    {
                        key: 'file_date',
                        label: 'File Date',
                        sortable: true,
                        formatter: (value) => { return this.formatDate( value ); }
                    },
                    {
                        key: 'ip_sync_file_id',
                        label: 'File ID',
                        sortable: true
                    },
                    {
                        key: 'ip_sync_file_name',
                        label: 'File Name',
                        sortable: true
                    },
                    {
                        key: 'carrier_name',
                        label: 'Block',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Activity',
                        sortable: true
                    },
                    {
                        key: 'row_number',
                        label: 'Row#',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'errors',
                        label: 'Errors',
                        sortable: false
                    },
                    {
                        key: 'policy_no',
                        label: 'Policy#',
                        sortable: true
                    },
                    {
                        key: 'claim_number',
                        label: 'Claim#',
                        sortable: true
                    },
                    {
                        key: 'upd_id',
                        label: 'UPD ID',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print',
                        sortable: false
                    },
                ],
            }
        },

        computed: {

            appliedFilters(){ return `?start_date=${this.start_date}&end_date=${this.end_date}&ltc_carrier_id=${this.ltc_carrier_id}&status=${this.status}&error=${this.error}&action=${this.action}`; },
            unwatchedFilters(){ return `&ip_sync_file_id=${this.ip_sync_file_id}`; }
        },

        methods: {

            queueAll(){

                let form = new Form();

                form.post( `${this.baseUrl}/queueAll` )
                    .then( () => {

                        this.loadTable();
                    })
            },
            formatErrors( errors ){

                return errors.map( err => err.error ).join( ' - ' );
            },
            rejectRecord( record ){

                let form = new Form({

                    'status' : 'rejected'
                });
                form.patch( `/business/parking_lots/${record.id}/triggerStatus` )
                    .then( res => {

                        this.loadTable();
                    })
            },
            queueRecord( record ){

                let form = new Form({

                    'status' : 'idle'
                });
                form.patch( `/business/parking_lots/${record.id}/triggerStatus` )
                    .then( res => {

                        this.loadTable();
                    })
            }
        },
    }
</script>

<style>

</style>
